<template>
  <div :id="id"
       class="o-echarts"></div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts'
import moment from 'moment'
let cityInsuranceChart = null
export default {
  name: 'CityInsuranceChart',
  props: {
    id: {
      type: String,
      required: false,
      default: 'cityInsuranceChart'
    },
    subtext: {
      type: String,
      required: false,
      default: moment().format('YYYY年MM月DD日')
    }
  },
  data () {
    return {
      //  id: 'cityInsuranceChart',//地图渲染容器id
      option: {
        title: {
          text: '',
          subtext: '（2020年4月26日）',
          left: 'right'
        },
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          // dimensions: ['area', '确权面积', '水稻政策性保险', '玉米政策性保险', '大豆政策性保险'],
          // source: [
          //   { area: '哈尔滨市', '确权面积': 1000, '水稻政策性保险': 1500, '玉米政策性保险': 1200, '大豆政策性保险': 1200,'政策性保险合计':3900 },
          //   { area: '齐齐哈尔市', '确权面积': 2000, '水稻政策性保险': 1800, '玉米政策性保险': 1600, '大豆政策性保险': 1000,'政策性保险合计':4400 },
          //   { area: '鹤岗市', '确权面积': 5000, '水稻政策性保险': 2000, '玉米政策性保险': 3000, '大豆政策性保险': 1489,'政策性保险合计':6489},
          //   { area: '双鸭山市', '确权面积': 10000, '水稻政策性保险': 2000, '玉米政策性保险': 3000, '大豆政策性保险': 1489,'政策性保险合计':6489},
          //   { area: '鸡西市', '确权面积': 8000, '水稻政策性保险': 5000, '玉米政策性保险': 8000, '大豆政策性保险': 1600,'政策性保险合计':14600 },
          // ]
        },
        legend: {
          top: 10,
          // left:20,
          itemGap: 10,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: '#333'
          },
          icon: 'rect'

          // data: ["水稻政策性保险", "玉米政策性保险", "大豆政策性保险", "确权面积"]
        },
        grid: {
          right: 50
        },
        toolbox: {
          show: true
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            // data: ["哈尔滨市 ", "齐齐哈尔市", "鹤岗市", "双鸭山市", "鸡西市"],

            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#aaa',
                type: 'dotted'
              }
            },
            axisLabel: {
              color: '#333'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: 'dotted'
              }
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              formatter (val) {
                if (val >= 10000) {
                  return val / 10000 + '万'
                } else return val
              }
            }
          }
        ],
        color: ['#6f7dfa', '#3f65e0', '#49b1e8', '#13d7d6', '#ff9023', 'rgba(139,131,243,.2)'],
        series: [
          // {
          // 	// name: "确权面积",
          // 	// data: [1000, 2000, 5000, 10000],
          // 	type: 'bar',
          // 	barWidth: 14
          // },
          // {
          // 	//name: "水稻政策性保险",
          // 	// data: [1500, 1800, 3000, 5000],
          // 	type: 'bar',
          // 	stack: '政策性保险',
          // 	barWidth: 14
          // },
          // {
          // 	//name: "玉米政策性保险",
          // 	// data: [2000, 2800, 800, 2400],
          // 	type: 'bar',
          // 	stack: '政策性保险'
          // },
          // {
          // 	//name: "大豆政策性保险",
          // 	//data: [1400, 1000, 700, 1200],
          // 	type: 'bar',
          // 	stack: '政策性保险'
          // },
          // {
          // 	//name: "小麦政策性保险",
          // 	//data: [1400, 1000, 700, 1200],
          // 	type: 'bar',
          // 	stack: '政策性保险'
          // }
          // {
          //   // name: "政策性保险合计",
          //   // data: [4900, 5600, 4500, 8600],
          //   type: "line",
          //   smooth: true,

          //   itemStyle: {
          //     opacity: 0
          //   },
          //   lineStyle: {
          //     opacity: 0
          //   },
          //   areaStyle: {
          //     color: "rgba(139,131,243,.2)"
          //   }
          // }
        ]
      }
    }
  },
  mounted () {
    // this.initMap()

  },
  watch: {},
  methods: {
    listenResize () {
      // 窗口改变大小
      if (cityInsuranceChart) {
        cityInsuranceChart.resize()
      }
    },

    initMap (optionData) {
      this.option.series = []
      // 设置时间
      // this.option.title.subtext = this.subtext || ''
      this.option.title.subtext = optionData.date || ''
      this.option.dataset = optionData || []

      let seriesLength = 0
      if (optionData.dimensions && optionData.dimensions.length > 0) {
        seriesLength = optionData.dimensions.filter(item => item.indexOf('保险') != -1).length
      }
      for (let i = 0; i <= seriesLength; i++) {
        this.option.series.push({
          type: 'bar',
          barWidth: 14,
          stack: '政策性保险'
        })
      }
      cityInsuranceChart = echarts.init(document.getElementById(this.id))
      cityInsuranceChart.setOption(this.option)
    }
  },

  components: {}
}
</script>

<style scoped lang="less">
.o-echarts {
  min-width: 30px;
  min-height: 30px;
  width: 100%;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/homechart/CityInsuranceChart.vue